import { format, parseISO } from 'date-fns';
import type { FC } from 'react';
import { ActionFeedbackDialog } from '../../../../../../components/ActionFeedbackDialog';
import type { Campaign } from '../types/offer.types';

interface ModalProgramarCampanhaProps {
  campanha: Campaign;
  onCancel: () => void;
  onConfirm: () => void;
  show: boolean;
}

const ModalProgramarCampanha: FC<ModalProgramarCampanhaProps> = ({ campanha, onCancel, onConfirm, show }) => (
  <ActionFeedbackDialog
    open={show}
    type="success"
    title="Programar Campanha"
    width="482px"
    onClose={onCancel}
    secondaryAction={{ label: 'Cancelar', onClick: onCancel }}
    primaryAction={{ label: 'Programar', onClick: onConfirm }}
    description={
      <>
        {campanha.name ? (
          <p>
            A campanha <strong>{campanha?.name}</strong> entrará em circulação no dia {format(parseISO(campanha?.starting_date), 'dd/MM/yyyy')} e ficará vigente
            até o dia {format(parseISO(campanha?.expiration_date), 'dd/MM/yyyy')}.
          </p>
        ) : null}
        <strong>Você quer confirmar a programação?</strong>
      </>
    }
  />
);

export default ModalProgramarCampanha;
